// Generated file by php first URL
export default {
  // 1 for ParaPrivilege
  // 2 for Mes Avantages PARA
  program: {},
  programs: {
    1:{id: 1,
      name: "Univers Pharmacie",
      programName: "Univers Pharmacie",
      website:"https://www.mesavantagespara.com/",
      app:"com.mesavantagespara.macartepara",
      graph:"Graph_UP.png",
      firstPage:"filesListing",
      benefit: "5%",
      style:"universPharmacie",
      sender:"UNIV PHARMA",
      debitAuth:['Univers Pharmacie','Mes avantages','Pharmacie du centre'],
      files:[
          "Contrat affiliation.pdf",
          "Dossier Adhesion Mes avantages PARA.pdf",
          "Adhesion centrale de referencement.pdf",
          "Autorisation teletransmission OffiSante.pdf",
          "Convention.pdf",
          "Dossier Adhesion Mon renouvellement.pdf",
          "Mandat de prelevement Pharmacie du Centre.pdf",
          "Mandat de prelevement UP.pdf",
          "Demarrage de communication.pdf",
          "Contrat point relais.pdf",
          "Contrat Community Management.pdf"

      ]},
    3:{id: 3,
      name: "Mes avantages PARA Ma carte",
      programName: "Mes avantages PARA",
      website:"https://www.mesavantagespara.com/",
      app:"com.mesavantagespara.macartepara",
      graph:"Graph_MAP.png",
      firstPage:"sellingPage",
      benefit: "De 3 à 6%",
      style:"paraPrivilege",
      sender:"Carte PARA",
      debitAuth:['Mes avantages']},
    4:{id: 4,
      name: "Mes avantages PARA Ma carte - Tarifs publics",
      programName: "Mes avantages PARA",
      website:"https://www.mesavantagespara.com/",
      app:"com.mesavantagespara.macartepara",
      graph:"Graph_MAP.png",
      firstPage:"sellingPage",
      benefit: "De 3 à 6%",
      style:"paraPrivilege",
      sender:"Carte PARA"},
    6:{id: 6,
      name: "Mes avantages PARA Ma carte Forum",
      programName: "Mes avantages PARA",
      website:"https://www.mesavantagespara.com/",
      app:"com.mesavantagespara.macartepara",
      graph:"Graph_MAP.png",
      firstPage:"sellingPage",
      benefit: "De 3 à 6%",
      style:"paraPrivilege",
      sender:"Carte PARA"},
     11:{id: 11,
      name: "Para Privilège Oté",
      programName: "Para Privilège",
      website:"https://www.paraprivilege.com/",
      app:"com.mesavantagespara.paraprivilege",
      graph:"Graph_Ote.png",
      firstPage:"sellingPage",
      benefit: "5%",
      style:"paraPrivilege",
      sender:"Carte PARA"},
     12:{id: 12,
      name: "Para Privilège",
      programName: "Para Privilège",
      website:"https://www.paraprivilege.com/",
      app:"com.mesavantagespara.paraprivilege",
      graph:"Graph_Para-Priv.png",
      firstPage:"sellingPage",
      benefit: "5%",
      style:"paraPrivilege",
      sender:"Carte PARA"},
     21:{id: 21,
      name: "Pharmacarte",
      programName: "Mes avantages PARA",
      website:"https://www.mesavantagespara.com/",
      app:"com.mesavantagespara.macartepara",
      graph:"Graph_MAP.png",
      firstPage:"sellingPage",
      benefit: "4%",
      style:"pharmaCarte",
      sender:"Pharmacarte"},
  },
  //urlBase: "https://api.mesavantagespara.com/online-subscription",
  //urlBase: "http://192.168.56.107/api-map-subscription",
  urlBase: "https://api-souscription.groupeuniverspharmacie.com/",
  isTest: false,
}


// WEBPACK FOOTER //
// ./src/config.js